import { z } from "zod";

export const bookedAppointmentsReadMetadataSchema = z.object({
  source: z.enum(["scheduling_index", "webecw", "cobalt"]),
  verifiedWithEhr: z.boolean(),
  canVerifyWithEhr: z.boolean(),
});
export type BookedAppointmentsReadMetadata = z.infer<typeof bookedAppointmentsReadMetadataSchema>;
